import React from 'react';
import DetailsPortal from './DetailsPortal';
import './OrderDetailsPanel.css';

const RequisiteDetailsPanel = ({ requisite, devices = [], devicesLoading = false, onClose, onEdit }) => {
  if (!requisite) return null;

  // Data is now located at the top level
  const requisiteData = requisite;

  // Function to get the device name by ref
  const getDeviceNameByRef = (deviceRef) => {
    if (!deviceRef) return '-';
    if (devicesLoading) return 'Loading...';
    const device = devices.find(d => (d.ref || d.id) === deviceRef);
    if (device) {
      return device.deviceName || device.DeviceName || device.device_name || deviceRef;
    }
    return deviceRef; // If not found, show the ref
  };

  const formatValue = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return String(value);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    try {
      const date = new Date(timestamp * 1000);
      if (isNaN(date.getTime())) {
        const date2 = new Date(timestamp);
        if (isNaN(date2.getTime())) return String(timestamp);
        return formatCustomDate(date2);
      }
      return formatCustomDate(date);
    } catch {
      return String(timestamp);
    }
  };

  const formatCustomDate = (date) =>
    `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()} ${String(
      date.getHours()
    ).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;

  // Format Status the same way as in the table
  const getStatus = () => {
    const status = (requisiteData.Status || requisiteData.status || '').toLowerCase();
    return {
      status,
      text: requisiteData.Status || requisiteData.status || '-'
    };
  };

  const status = getStatus();
  const accountNumber = requisiteData.AccountNumber || requisiteData.accountNumber || requisiteData.account_number || '-';
  const bank = requisiteData.Bank || requisiteData.bank || '-';
  const currency = requisiteData.Currency || requisiteData.currency || '-';
  const owner = requisiteData.NameSurname || requisiteData.nameSurname || requisiteData.name_surname || '-';
  const deviceName = getDeviceNameByRef(requisiteData.device || requisiteData.Device);
  const created = formatDate(requisiteData.Created || requisiteData.created || requisite.create_time || requisiteData.create_time);
  const changed = formatDate(requisiteData.LastChanged || requisiteData.lastChanged || requisite.change_time || requisiteData.change_time);

  return (
    <DetailsPortal>
    <div className="order-details-overlay" onClick={onClose}>
      <div className="order-details-panel" onClick={(e) => e.stopPropagation()}>
        <div className="order-details-header">
          <h2>Requisite Details</h2>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            {onEdit && (
              <button 
                className="edit-button"
                onClick={() => {
                  if (onEdit) {
                    onEdit(requisite);
                  }
                }}
              >
                Edit
              </button>
            )}
            <button type="button" className="close-button" onClick={onClose}>Close</button>
          </div>
        </div>
        <div className="order-details-content">
          <div className="order-summary">
            <div className="summary-main">
              <span className="summary-label">Requisite</span>
              <span className="summary-primary">{owner}</span>
              <span className="summary-secondary">{bank}</span>
            </div>
            <div className="summary-chips">
              <span className={`status-badge status-${status.status}`}>{status.text}</span>
              <span className="summary-chip">Currency: {currency}</span>
              <span className="summary-chip">Device: {deviceName}</span>
            </div>
          </div>

          <div className="detail-section">
            <h3>Details</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Account Number</span>
                <span className="detail-value">{formatValue(accountNumber)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Bank</span>
                <span className="detail-value">{formatValue(bank)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Currency</span>
                <span className="detail-value">{formatValue(currency)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Device</span>
                <span className="detail-value">{formatValue(deviceName)}</span>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h3>Timeline</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Created</span>
                <span className="detail-value">{created}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Last Changed</span>
                <span className="detail-value">{changed}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </DetailsPortal>
  );
};

export default RequisiteDetailsPanel;
